import { nanoid } from 'nanoid'
import { type ActionItem, toastStore } from 'shared/ui'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { logger } from 'shared/lib'
import { type IUser } from 'entities/Users'
import { type RowInbox } from 'entities/Inbox/model/Table/RowInbox'
import { InboxesApi } from 'entities/Inbox'
import { type IEntitiesStore } from 'entities/EntitiesExport'

export const makeInboxOwnerAction = (
  member: IUser,
  inbox: RowInbox,
  entities: IEntitiesStore,
  onSuccess?: () => void | Promise<void>
) => {
  const modalId = nanoid()

  modalStore.addModal({
    id: modalId,
    type: ModalTypeList.INFO,
    title: 'Make inbox owner?',
    desc: `Make ${member.full_name} the new owner of the ${inbox.name} inbox. This will replace ${
      inbox.owner?.full_name ?? 'the current owner'
    }.`,
    primaryAction: {
      text: 'Yes, make owner',
      onAction: async () => {
        try {
          await InboxesApi.changeInboxOwner(inbox.id, {
            owner_id: member.id,
          })
          inbox.origin.changeOwnerId(member.id)
          toastStore.add({
            type: 'success',
            title: 'Inbox owner changed',
          })

          entities.inboxesStore.fetchPersonalInboxes()
          onSuccess?.()
          modalStore.closeModal(modalId)
        } catch (error) {
          logger.error(error)

          toastStore.add({
            type: 'error',
            title: 'Something went wrong. Please try again',
          })
        }
      },
    },
    secondaryAction: {
      text: 'Cancel',
      onAction: () => {
        modalStore.closeModal(modalId)
      },
    },
  })
}

export const makeInboxOwner = (
  member: IUser,
  inbox: RowInbox,
  entities: IEntitiesStore,
  onSuccess?: () => void | Promise<void>
): ActionItem => {
  return {
    text: 'Make inbox owner',
    icon: 'inboxes2',
    onAction: () => {
      makeInboxOwnerAction(member, inbox, entities, onSuccess)
    },
  }
}
